import { ClientManagementButtonBack } from './ButtonBack';

export const ButtonBack = ClientManagementButtonBack;
